var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 0C3.5888 0 0 3.58885 0 8.00005C0 12.4112 3.5888 16 8 16C12.4112 16 16 12.4112 16 8.00005C16 3.58885 12.4112 0 8 0ZM8 14.5455C4.39079 14.5455 1.45455 11.6092 1.45455 8.00005C1.45455 4.39088 4.39079 1.45455 8 1.45455C11.6092 1.45455 14.5455 4.39088 14.5455 8.00005C14.5455 11.6092 11.6092 14.5455 8 14.5455Z",
    fill: "#637083"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.00002 3.39392C7.46543 3.39392 7.03052 3.82912 7.03052 4.36405C7.03052 4.8985 7.46543 5.33332 8.00002 5.33332C8.53462 5.33332 8.96952 4.8985 8.96952 4.36405C8.96952 3.82912 8.53462 3.39392 8.00002 3.39392Z",
    fill: "#637083"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.99998 6.78784C7.59833 6.78784 7.27271 7.11347 7.27271 7.51511V11.8788C7.27271 12.2804 7.59833 12.606 7.99998 12.606C8.40163 12.606 8.72725 12.2804 8.72725 11.8788V7.51511C8.72725 7.11347 8.40163 6.78784 7.99998 6.78784Z",
    fill: "#637083"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.ed38b049203bad47ccd783614b6d5bcb.svg";
export { ForwardRef as ReactComponent };